import { CandidateWaitingRoomStatus } from "@/types";

const statusColorMap: Record<
  CandidateWaitingRoomStatus,
  { dotColor: string; textColor: string; backgroundColor: string }
> = {
  New: {
    backgroundColor: "bg-blue-100",
    textColor: "text-blue-600",
    dotColor: "bg-blue-600",
  },
  "Invited to Apply": {
    backgroundColor: "bg-indigo-100",
    textColor: "text-indigo-600",
    dotColor: "bg-indigo-600",
  },
  "Application Under Review": {
    backgroundColor: "bg-violet-100",
    textColor: "text-violet-600",
    dotColor: "bg-violet-600",
  },
  Interviewing: {
    backgroundColor: "bg-red-100",
    textColor: "text-red-600",
    dotColor: "bg-red-600",
  },
  "Interview Under Review": {
    backgroundColor: "bg-orange-100",
    textColor: "text-orange-600",
    dotColor: "bg-orange-600",
  },
  "Ready For MAP": {
    backgroundColor: "bg-amber-100",
    textColor: "text-amber-600",
    dotColor: "bg-amber-600",
  },
  "Taking/Sent MAP": {
    backgroundColor: "bg-yellow-100",
    textColor: "text-yellow-600",
    dotColor: "bg-yellow-600",
  },
  "MAP Under Review": {
    backgroundColor: "bg-lime-100",
    textColor: "text-lime-600",
    dotColor: "bg-lime-600",
  },
  Joined: {
    backgroundColor: "bg-green-100",
    textColor: "text-green-600",
    dotColor: "bg-green-600",
  },
  "Dropped out": {
    backgroundColor: "bg-slate-100",
    textColor: "text-slate-600",
    dotColor: "bg-slate-600",
  },
  Rejected: {
    backgroundColor: "bg-stone-100",
    textColor: "text-stone-600",
    dotColor: "bg-stone-600",
  },
};

const candidateStatusToColors = (status?: CandidateWaitingRoomStatus) =>
  statusColorMap[status ?? "Joined"];

export default candidateStatusToColors;
